module.exports = __webpack_public_path__ + "static/media/iphone_13_mini_pink.f151f758.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_13_mini_pink.png
// module id = 2111
// module chunks = 0